// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1kRn_","info":"PatientInfo_info__1Fjjr"};